<template>
  <div>
    {{destination}}
  </div>
</template>

<script>
export default {
  name: 'DestinationCellRenderer',
  data() {
    return {
      destination: null
    }
  },
  created() {
    this.destination = this.params.value.destination;
  }
}
</script>
